import { Activity } from "../currentUserPresence/types";

// Decides whether a UserPresenceChanged update should end the wrap-up currently tracked in the
// client's wrap-up store (assuming the interaction it's for was already found to still be active —
// see the caller). The decision is made on identity: the update must name the very wrap-up we are
// tracking (`wrapupMediaId`), the same mediaId comparison already used in WorkspacePanel,
// MessagingInteractionPanel and shouldCancelActiveInteractionForWrapup. A plain capacity
// recalculation triggered by an UNRELATED interaction closing (e.g. a skip-wrap-up/no-wrap-up text
// auto-close) carries no wrapupMediaId, or a different one — treating that as "my wrap-up ended"
// was silently ending a different, still-active wrap-up (e.g. an active call's).
// The one exception is a new interaction being offered while in wrap-up (activity === Offering),
// which is meant to interrupt/end it (surfaced by the caller as WrapUpEndType.ByOffering).
export const shouldEndWrapUpForPresenceUpdate = (
	data: { activity: string; wrapupMediaId?: string },
	wrapUpReason: string | undefined,
	agentActivity: string,
	wrapUpMediaId: string | undefined
): boolean => {
	if (data.activity === Activity.BusyInACall || agentActivity === wrapUpReason) {
		return false;
	}

	const isForThisWrapUp =
		!!data.wrapupMediaId && data.wrapupMediaId === wrapUpMediaId;

	return isForThisWrapUp || isNewOfferingWhileInWrapUp(data.activity);
};

export const isNewOfferingWhileInWrapUp = (activity: string): boolean =>
	activity === Activity.Offering;
